import { ArrowDownward, ArrowUpward } from '@mui/icons-material'
import { Button } from '@mui/material'
import { t } from 'i18next'
import { StyledContainerRowBetween } from '../../../../styles/ContainerStyles'
import FilterButton from '../../../Button/FilterButton'
import { PushNotificationFilterType } from './NotificationSidebar'

type SortAndFilterButtonsProps = {
  isDownSm: boolean
  isSortAsc: boolean
  isFilterMenuOpen: boolean
  toggleSortButton: () => void
  handleToggleFilter: (event: React.MouseEvent<HTMLButtonElement>) => void
  selectedFilters: PushNotificationFilterType
}

const SortAndFilterButtons = ({
  isDownSm,
  isSortAsc,
  isFilterMenuOpen,
  toggleSortButton,
  handleToggleFilter,
  selectedFilters,
}: SortAndFilterButtonsProps) => {
  const selectedFiltersCount = selectedFilters.reason.length + selectedFilters.isRead.length

  return (
    <StyledContainerRowBetween
      sx={{
        flexDirection: isDownSm ? 'column' : 'row',
        justifyContent: 'end',
        mt: 1,
        gap: isDownSm ? 0.5 : 1,
      }}
    >
      <Button
        onClick={toggleSortButton}
        variant="text"
        color="inherit"
        size="small"
        sx={{
          width: 167,
          alignSelf: 'end',
          justifyContent: 'flex-start',
        }}
        startIcon={isSortAsc ? <ArrowUpward /> : <ArrowDownward />}
      >
        {isSortAsc ? t('components.notificationSidebar.sortAsc') : t('components.notificationSidebar.sortDesc')}
      </Button>
      <FilterButton
        sx={{ width: 128, alignSelf: 'end' }}
        className={isFilterMenuOpen ? 'selected' : 'auto'}
        onClick={handleToggleFilter}
        selectedFiltersCount={selectedFiltersCount}
      />
    </StyledContainerRowBetween>
  )
}

export default SortAndFilterButtons
